import React, { useState } from 'react';
import { Drawer } from '@material-ui/core';
import { useAppLanguage } from '@hooks/index';
import interceptCloseDrawer from '@services/drawer';
import { safeJsonParse } from '@commonClient2/services/json';
import { AppBar, AppBarContent } from '@commonClient2/components';
import { SessionStorageKeys } from '@enums/index'; 
import Sidebar from '../Sidebar';

/**
 * @param {{
 *  color?: import('@material-ui/core').PropTypes.Color;
 *  name: string;
 *  pageName: string;
 * }} param0
 */
const AdminAppBar = ({
    color = 'inherit',
    name,
    pageName,
}) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const appLanguage = useAppLanguage();

    const configs = {
        appEnvironment: sessionStorage.getItem(SessionStorageKeys.appEnvironment) || '',
        appVersion: sessionStorage.getItem(SessionStorageKeys.version) || '',
        isMultiLanguage: safeJsonParse(sessionStorage.getItem(SessionStorageKeys.isMultiLanguage)) || false,
    };

    const closeDrawer = () => setIsDrawerOpen(false);
    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawerIntercepted = interceptCloseDrawer(closeDrawer);

    return (
        <AppBar color={color}>
            <AppBarContent
                name={name}
                pageName={pageName}
                onSidebarIconClick={openDrawer}
                appLanguage={appLanguage}
                configs={configs}
            />
            <Drawer
                anchor="left"
                open={isDrawerOpen}
                onClose={closeDrawerIntercepted}
            >
                <Sidebar
                    title={pageName}
                    onIconTitleClick={closeDrawer}
                />
            </Drawer>
        </AppBar>
    );
};

export default AdminAppBar;
